/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import dashboardComponentTypes from '../enum/dashboardComponentTypes';

var adhocDesignerReportTypeToDashboardComponentTypeMap = {
    'olap_ichart': dashboardComponentTypes.CHART,
    'olap_crosstab': dashboardComponentTypes.CROSSTAB,
    'ichart': dashboardComponentTypes.CHART,
    'crosstab': dashboardComponentTypes.CROSSTAB,
    'table': dashboardComponentTypes.TABLE
};
export default function (viewType) {
    return adhocDesignerReportTypeToDashboardComponentTypeMap[viewType];
}